export default {
  imgs: [
    {
      name: "肥龙_1",
      src: require("@img/pets/green_1.png"),
    },
    {
      name: "肥龙_2",
      src: require("@img/pets/green_2.png"),
    },
    {
      name: "肥龙_3",
      src: require("@img/pets/green_3.png"),
    },
    {
      name: "大嘴鸟_1",
      src: require("@img/pets/red_1.png"),
    },
    {
      name: "大嘴鸟_2",
      src: require("@img/pets/red_2.png"),
    },
    {
      name: "大嘴鸟_3",
      src: require("@img/pets/red_3.png"),
    },
    {
      name: "双头龙_1",
      src: require("@img/pets/blue_1.png"),
    },
    {
      name: "双头龙_2",
      src: require("@img/pets/blue_2.png"),
    },
    {
      name: "双头龙_3",
      src: require("@img/pets/blue_3.png"),
    },
    {
      name: "统一大小_肥龙_1",
      src: require("@img/pets/fitsize/green_1.png"),
    },
    {
      name: "统一大小_肥龙_2",
      src: require("@img/pets/fitsize/green_2.png"),
    },
    {
      name: "统一大小_肥龙_3",
      src: require("@img/pets/fitsize/green_3.png"),
    },
    {
      name: "统一大小_大嘴鸟_1",
      src: require("@img/pets/fitsize/red_1.png"),
    },
    {
      name: "统一大小_大嘴鸟_2",
      src: require("@img/pets/fitsize/red_2.png"),
    },
    {
      name: "统一大小_大嘴鸟_3",
      src: require("@img/pets/fitsize/red_3.png"),
    },
    {
      name: "统一大小_双头龙_1",
      src: require("@img/pets/fitsize/blue_1.png"),
    },
    {
      name: "统一大小_双头龙_2",
      src: require("@img/pets/fitsize/blue_2.png"),
    },
    {
      name: "统一大小_双头龙_3",
      src: require("@img/pets/fitsize/blue_3.png"),
    },
    {
      name: "无宠物背景",
      src: require("@img/pets/add-btn.png"),
    },
    {
      name: "品质框_绿",
      src: require("@img/pets/pet-box_1.png"),
    },
    {
      name: "品质框_蓝",
      src: require("@img/pets/pet-box_2.png"),
    },
    {
      name: "品质框_紫",
      src: require("@img/pets/pet-box_3.png"),
    },
    {
      name: "品质框_金",
      src: require("@img/pets/pet-box_4.png"),
    },
    // v2.0
    {
      name: "雪怪_1",
      src: require("@img/pets/snow_4_1.png"),
    },
    {
      name: "雪怪_2",
      src: require("@img/pets/snow_4_2.png"),
    },
    {
      name: "雪怪_3",
      src: require("@img/pets/snow_4_3.png"),
    },
    {
      name: "剑齿虎_1",
      src: require("@img/pets/tiger_5_1.png"),
    },
    {
      name: "剑齿虎_2",
      src: require("@img/pets/tiger_5_2.png"),
    },
    {
      name: "剑齿虎_3",
      src: require("@img/pets/tiger_5_3.png"),
    },
    {
      name: "大猩猩_1",
      src: require("@img/pets/gorilla_6_1.png"),
    },
    {
      name: "大猩猩_2",
      src: require("@img/pets/gorilla_6_2.png"),
    },
    {
      name: "大猩猩_3",
      src: require("@img/pets/gorilla_6_3.png"),
    },
    {
      name: "统一大小_雪怪_1",
      src: require("@img/pets/fitsize/snow_4_1.png"),
    },
    {
      name: "统一大小_雪怪_2",
      src: require("@img/pets/fitsize/snow_4_2.png"),
    },
    {
      name: "统一大小_雪怪_3",
      src: require("@img/pets/fitsize/snow_4_3.png"),
    },
    {
      name: "统一大小_剑齿虎_1",
      src: require("@img/pets/fitsize/tiger_5_1.png"),
    },
    {
      name: "统一大小_剑齿虎_2",
      src: require("@img/pets/fitsize/tiger_5_2.png"),
    },
    {
      name: "统一大小_剑齿虎_3",
      src: require("@img/pets/fitsize/tiger_5_3.png"),
    },
    {
      name: "统一大小_大猩猩_1",
      src: require("@img/pets/fitsize/gorilla_6_1.png"),
    },
    {
      name: "统一大小_大猩猩_2",
      src: require("@img/pets/fitsize/gorilla_6_2.png"),
    },
    {
      name: "统一大小_大猩猩_3",
      src: require("@img/pets/fitsize/gorilla_6_3.png"),
    },
    {
      name: "扎堆的御三家",
      src: require("@img/pets/group.png"),
    },
    // emos
    {
      name: "宠物表情背景",
      src: require("@img/pets/emo-bg.png"),
    },
    {
      name: "吃食表情",
      src: require("@img/pets/emos/feed.gif"),
    },
    // emos end
    // v2.0end
  ],
};
